import React, {useState, useEffect } from "react"
import _ from "lodash"
import { InputText_s } from "styles/input-styles"

interface TextEditable {
  attrs?: Function,
  data: [],
  disabled?: boolean,
  field: string|any[],
  persist: Function,
  onFocus: Function,
  className: string
}

const TextInput = (props: TextEditable) => {
  const initialValue = _.get(props.data, props.field)
  const [val, updateVal] = useState<string|null>(_.isNil(initialValue) ? "" : initialValue)

  function update(val:string|null): void {
    if(props.field === "code") val = _.replace(val, /\*/g, "")

    props.persist(val, props.field)
    updateVal(val);
  }

  useEffect(() => {
    if (_.isNil(initialValue) && !_.isNil(val)){
      updateVal("")
    }
    if (!_.isNil(initialValue)) {
      updateVal(initialValue)
    }
  }, [initialValue])

  const attrs = props.attrs && props.attrs(props.field) || {}

  return (
    <InputText_s
      {...attrs}
      type="text"
      className={props.className}
      disabled={props['disabled']}
      value={val}
      onChange={e => updateVal((e.target as HTMLInputElement).value)}
      onKeyDown={e => {
        switch(e.key) {
          case "Enter":
            update((e.target as HTMLInputElement).value)
            break
          case "Tab":
            update((e.target as HTMLInputElement).value)
            break
        }
      }}
      onFocus={_e => props.onFocus ? props.onFocus() : (!_.isNil(val) && val !== "") && update(val)}
      onBlur={_e => update(val)}
    />
  )
}

export default TextInput
